export default "__VITE_ASSET__wGYsfBnH__";